jQuery($ => {
    class FeaturedGroups {
      constructor(element, args = []) {
        this._            = element;
        this._element     = $(element);
        this._list        = this._element.find('.o-featured-groups__cards .m-group-cards__list');
        this._items       = this._element.find('.o-featured-groups__cards .m-group-cards__item');
        this._prevArrow   = this._element.find('.o-featured-groups__arrows .m-slider-arrows__prev');
        this._nextArrow   = this._element.find('.o-featured-groups__arrows .m-slider-arrows__next');
        this._progressBar = this._element.find('.o-featured-groups__progress-bar');
        this._listCount   = $(this._items).length;

  
        this._args = $.extend({
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          prevArrow: this._prevArrow,
          nextArrow: this._nextArrow,
          variableWidth: true,
          responsive: [{
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: false,
            }
          }]
        }, args);
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._list.slick(this._args).on('afterChange swipe', function(event, slick, direction){
          this._currentSlide = $(this).slick('slickCurrentSlide');
          this._innerBar    = $('.o-featured-groups__progress-bar .a-slider-progress-bar__inner');
          this._percentage  = parseInt(this._currentSlide * 100 / slick.slideCount);
          
          this._innerBar.animate({
            "left":  this._percentage + '%'
          });
        });
        this._element.trigger('setup-slick', this);
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.featured_groups = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].featured_groups = new FeaturedGroups(_[i], opt);
        else
          ret = _[i].featured_groups[opt].apply(_[i].featured_groups, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.o-featured-groups').featured_groups();
});